module.exports = __webpack_public_path__ + "static/media/1news.c89b51b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AsSeenOnTV/brands/1news.png
// module id = 575
// module chunks = 0